module.exports = __webpack_public_path__ + "static/img/appjj.03e2574.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appjj.jpg
// module id = iA4q
// module chunks = 1